let invoiceRowGroupButtons = $('.group-invoice-row');
let rowGroupingActions = $('.row-grouping-actions');
let rowGroups = $('.row-group');

// /** Disable default checkbox behaviour */
// invoiceRowGroupButtons.find('input').change((e) => e.preventDefault());

$(document).on('click', '.group-invoice-row', function (e) {
    let checkbox = $(this).find('input');
    let vatRateId = checkbox.data('vat-rate-id');

    /** Trigger checkbox toggle if not directly clicked on checkbox */
    if (checkbox.prop('disabled')) {
        return;
    }
    if (!$(e.target).is('input')) {
        checkbox.prop('checked', !checkbox.prop('checked'));
    }

    /** Disable other checkboxes of other vat rate or enable all checkboxes */
    if (invoiceRowGroupButtons.find('input:checked').length > 0) {
        invoiceRowGroupButtons.find('input[data-vat-rate-id!=' + vatRateId + ']')
            .prop('disabled', true)
            .prop('checked', false)
            .each(function (k, item) {
                let row = $(item).closest('.group-invoice-row');
                if (!row.hasClass('tooltip-enabled')) {
                    row.attr('title', rowGroupingActions.data('no-vat-combination'))
                        .addClass('tooltip-enabled')
                        .tooltip()
                }
            });

        rowGroups.filter('[data-vat-rate-id="' + vatRateId + '"]').show();
    } else {
        invoiceRowGroupButtons.find('input')
            .prop('disabled', false)
            .prop('checked', false)
            .each(function (k, item) {
                let row = $(item).closest('.group-invoice-row');
                if (row.hasClass('tooltip-enabled')) {
                    row.attr('title', '')
                        .removeClass('tooltip-enabled')
                        .tooltip('dispose')
                }
            });
        rowGroups.hide().find('input').prop('checked', false);
    }


    if (!$(this).hasClass('active')) {
        activateRowGrouping()
    }
})

rowGroupingActions.find('.cancelGrouping').click(function () {
    invoiceRowGroupButtons.removeClass('active');
    invoiceRowGroupButtons.find('.form-check').hide();
    invoiceRowGroupButtons.find('.activate').show();
    invoiceRowGroupButtons.find('input').prop('checked', false);
    rowGroupingActions.slideUp();
});

rowGroupingActions.find('.saveGrouping').click(function () {
    let groupId = undefined;
    let description = undefined;
    if (rowGroups.find('input:checked')) {
        groupId = rowGroups.find('input:checked').first().val();
    }

    if (!groupId) {
        description = prompt(rowGroupingActions.data('prompt-description'));
    }

    let ids = [];
    invoiceRowGroupButtons.find('input:checked').each((k, input) => {
        ids.push(input.value);
    })

    $.ajax({
        url: rowGroupingActions.data('group-route'),
        method: 'POST',
        data: {
            ids: ids,
            row_id: groupId ?? null,
            description: description ?? ''
        },
        complete: function () {
            window.location.reload();
        }
    });
});

function activateRowGrouping() {
    rowGroupingActions.slideDown();
    invoiceRowGroupButtons.find('.activate').hide();
    invoiceRowGroupButtons.find('.form-check').show();
    invoiceRowGroupButtons.addClass('active');
}
